import { render, staticRenderFns } from "./dashboard-sidebar.html?vue&type=template&id=3154bff3&scoped=true&"
import script from "./dashboard-sidebar.js?vue&type=script&lang=js&"
export * from "./dashboard-sidebar.js?vue&type=script&lang=js&"
import style0 from "./dashboard-sidebar.scss?vue&type=style&index=0&id=3154bff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154bff3",
  null
  
)

export default component.exports